import { PERMISSION_KEYS } from 'constants-permissions';
import { useUserDataContext } from 'lane-shared/hooks';
import { hasPermissionOrSuperUser } from 'lane-shared/helpers/hasPermission';

export function hasChargeVerificationPermission(
  user: Parameters<typeof hasPermissionOrSuperUser>[0] | null,
  groupId: string
): boolean {
  return Boolean(
    user &&
      hasPermissionOrSuperUser(
        user,
        [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_CHARGE_VERIFICATION_MANAGE],
        groupId
      )
  );
}

export function useChargeVerificationPermission(groupId: string): boolean {
  const { user } = useUserDataContext();

  return hasChargeVerificationPermission(user, groupId);
}
